import { useQuery, useMutation, useQueryClient } from "react-query";
import {
  GetEnumsValue,
  GetAllPerson,
  GetAllEducationalDegree,
  GetAllEmployeeStatus,
  AddPerson,
  GetAllProvince,
  GetCitiesByProvince,
  EditPersonInfo,
  GetBankInfo,
  GetAllPersonBankInfo,
  AddPersonBankInfo,
  DeletePersonBankInfo,
  EditPersonBankInfo,
  AddUploadDocument,
  GetUploadDocument,
  AddUploadContract,
  GetPersonContrat,
  DeleteContract,
  AddDependentInfo,
  GetDependentInfo,
  AddInsuranceInfo,
  AddUserAccount,
  EditContract,
  UpdateDocument,
  GetBankInfoForPeron,
} from "../api";
import { useDispatch } from "react-redux";
import { getOrderTotalR } from "../../../../General/Store/GeneralSlice";
import {
  AddContractR,
  AddDocumentsR,
  AddFurtherInformationR,
  AddInsuranceR,
  AddPersonIdR,
  AddPersonInfoR,
  UpdatePersonPostR,
  getUploadDocumentListR,
} from "../Components/userSlice/UserSlice";
import { customApi } from "../../../../CustomHoock/CustomApi";
let cacheTime = 5 * 60 * 1000;
let staleTime = 10 * 60 * 1000;
/**==============================================
 *                GetEnumsValue
 *  
  
 *=============================================**/
const useGetEnumsValue = (reqUnitsBody) => {
  return useQuery(["GetEnumsValue", reqUnitsBody], GetEnumsValue, {
    enabled: !!reqUnitsBody,
    refetchOnWindowFocus: false,
    cacheTime: cacheTime,
    staleTime: staleTime,
    onSuccess: (data) => {
      return data;
    },

    select: (data) => {
      let enums = data?.data.data;
      //convert enums array to object
      const enumsObj = enums?.reduce((acc, value) => {
        acc[value.enumType] = value.enumValues;
        return acc;
      }, {});
      return enumsObj;
    },
  });
};
/**==============================================
 *                GetAllPerson
 *  
  
 *=============================================**/
const useGetAllPerson = (reqBody,newBody) => {
  let mainBody={...reqBody,...newBody};
  const dispatch = useDispatch();
  let totalRecord;
  return useQuery(["GetAllPerson", mainBody], GetAllPerson, {
    enabled: !!mainBody,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onSuccess: (data) => {
      dispatch(getOrderTotalR(totalRecord));
      return data;
    },

    select: (data) => {
      totalRecord = data?.data.totalRecord; //for pagnation
      let allPerson = data?.data.data;

      return allPerson;
    },
  });
};

/**==============================================
 *                Delete Person
 *
 *
 *
 *
 *=============================================**/
const useDeletePeson = (handleSuccess, handleFailed) => {
  const queryClient = useQueryClient();
  return useMutation(
    (body) =>
      customApi({
        apiType: "delete",
        url: "/api/v1/Person/DeletePerson",
        queryparameters: "personId",
        reactQuery: "mutate",
        requestBody: body,
      }),
    {
      onSuccess: (data) => {
        handleSuccess();
      },
      onError: (error) => {
        handleFailed();
      },
    }
  );
};
/**==============================================
 *                GetAllEducationalDegree
 *
 *=============================================**/
const useGetAllEducationalDegree = () => {
  return useQuery(["GetAllEducationalDegree"], GetAllEducationalDegree, {
    refetchOnWindowFocus: false,
    select: (data) => {
      let EducationalDegree = data?.data.data;
      return EducationalDegree;
    },
    cacheTime: cacheTime,
    staleTime: staleTime,
  });
};
/**==============================================
 *                GetAllEmployeeStatus
 *
 *=============================================**/
const useGetAllEmployeeStatus = () => {
  return useQuery(["GetAllEmployeeStatus"], GetAllEmployeeStatus, {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      return data;
    },
    onError: (error) => {},
    select: (data) => {
      let EmployeeStatus = data?.data.data;

      return EmployeeStatus;
    },
    cacheTime: cacheTime,
    staleTime: staleTime,
  });
};
/**==============================================
 *               AddPerson
 *
 *=============================================**/
const useAddPerson = (handleSuccess, handleFailed) => {
  const queryClient = useQueryClient();
  return useMutation(AddPerson, {
    onSuccess: (data) => {
      queryClient.invalidateQueries("GetAllPerson");
      handleSuccess();
    },
    onError: () => {
      handleFailed();
    },
  });
};

const useGetAllProvince = () => {
  return useQuery(["GetAllProvince"], GetAllProvince, {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      return data;
    },
    onError: (error) => {},
    select: (data) => {
      let province = data?.data.data;
      return province;
    },
    cacheTime: cacheTime,
    staleTime: staleTime,
  });
};

const useGetCitiesByProvince = () => {
  return useMutation(GetCitiesByProvince, {
    cacheTime: Infinity,
    onSuccess: (data) => {
      return data.data.data;
    },
    onError: (error) => {},
  });
};

/**==============================================
 *                EditPersonInfo
 *=============================================**/
const useEditPersonInfo = (handleSuccess, handleFailed) => {
  const dispatch = useDispatch();
  return useMutation(EditPersonInfo, {
    cacheTime: Infinity,
    onSuccess: (data) => {
      handleSuccess();
      dispatch(AddFurtherInformationR(true));
    },
    onError: (error) => {
      handleFailed();
    },
  });
};
const useGetBankInfo = () => {
  return useQuery(["GetBankInfo"], GetBankInfo, {
    refetchOnWindowFocus: false,
    cacheTime: cacheTime,
    staleTime: staleTime,
    onSuccess: (data) => {
      return data;
    },
    select: (data) => {
      let bankInfo = data?.data.data;

      return bankInfo;
    },
  });
};

const useGetBankInfoForPeron = () => {
  return useQuery(["GetBankInfoForPeron"], GetBankInfoForPeron, {
    refetchOnWindowFocus: false,
    cacheTime: cacheTime,
    staleTime:staleTime,
    onSuccess: (data) => {
      return data;
    },
    select: (data) => {
      let bankInfo = data?.data.data;

      return bankInfo;
    },
  });
};


const useGetPersonBankInfo = (body) => {
  return useQuery(["GetPersonBankInfo", body], GetAllPersonBankInfo, {
    enabled: !!body,
    refetchOnWindowFocus: false,
    cacheTime: cacheTime,
    staleTime: staleTime,
    onSuccess: (data) => {
      return data;
    },

    select: (data) => {
      return data?.data.data;
    },
  });
};

const useAddPersonBankInfo = (handleSuccess, handleFailed) => {
  const queryClient = useQueryClient();
  return useMutation(AddPersonBankInfo, {
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onSuccess: () => {
      queryClient.invalidateQueries("GetPersonBankInfo");
      handleSuccess();
    },
    onError: () => {
      handleFailed();
    },
  });
};
/**=======================
 *     DeletePersonBankInfo
 *========================**/
const useDeletePersonBankInfo = (handleSuccess, handleFailed) => {
  const queryClient = useQueryClient();
  return useMutation(DeletePersonBankInfo, {
    onSuccess: () => {
      queryClient.invalidateQueries("GetPersonBankInfo");
      handleSuccess();
    },
    onError: () => {
      handleFailed();
    },
  });
};

const useEditPersonBankInfo = (handleSuccess, handleFailed) => {
  const queryClient = useQueryClient();
  return useMutation(EditPersonBankInfo, {
    onSuccess: () => {
      queryClient.invalidateQueries("GetPersonBankInfo");
      handleSuccess();
    },
    onError: () => {
      handleFailed();
    },
  });
};

const useUploadDocument = (handleSuccess, handleFailed) => {
  const dispatch = useDispatch();
  return useMutation(AddUploadDocument, {
    onSuccess: () => {
      handleSuccess();
      dispatch(AddDocumentsR(true));
    },
    onError: () => {
      handleFailed();
    },
  });
};

const useUpdateDocument = (handleSuccess, handleFailed) => {
  const dispatch = useDispatch();
  return useMutation(UpdateDocument, {
    refetchOnWindowFocus: false,
    onSuccess: () => {
      handleSuccess();
      dispatch(AddDocumentsR(true));
      dispatch(AddPersonIdR(""));
    },
    onError: () => {
      handleFailed();
    },
  });
};
/**=======================
 *     GetUploadDocument
 *
 *========================**/
const useGetDocument = (personId, reFetchState) => {
  const dispatch = useDispatch();
  return useQuery(["GetDocument", personId], GetUploadDocument, {
    enabled: !!personId && reFetchState,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onSuccess: (data) => {
      dispatch(getUploadDocumentListR(data));
      return data;
    },
    onError: () => {},
    select: (data) => {
      let document = data?.data.data;
      return document;
    },
  });
};

const useUploadContract = (handleSuccess, handleFailed) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation(AddUploadContract, {
    refetchOnWindowFocus: false,
    onSuccess: () => {
      queryClient.invalidateQueries("GetPersonContract");
      handleSuccess();
      dispatch(AddContractR(true));
    },
    onError: (error) => {
      handleFailed();
      const errorList = error.response.data.resourceKeyResult.resourceKeyList;
      if (errorList) {
        errorList.forEach((errorListItem) => {
          const element = errorListItem.resourceKeys;
          element.forEach((errorText) => {
            console.error("...", errorText);
            handleFailed(errorText);
          });
        });
      }
    },
  });
};

const useEditContract = (handleSuccess, handleFailed) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation(EditContract, {
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onSuccess: () => {
      queryClient.invalidateQueries("GetPersonContract");
      handleSuccess();
      dispatch(AddContractR(true));
    },
    onError: (error) => {
      handleFailed();
      const errorList = error.response.data.resourceKeyResult.resourceKeyList;
      if (errorList) {
        errorList.forEach((errorListItem) => {
          const element = errorListItem.resourceKeys;
          element.forEach((errorText) => {
            console.error("...", errorText);
            handleFailed(errorText);
          });
        });
      }
    },
  });
};

/**=======================
 *     useDeleteContract
 *========================**/
const useDeleteContract = (handleSuccess, handleFailed, setReset) => {
  const queryClient = useQueryClient();
  return useMutation(DeleteContract, {
    refetchOnWindowFocus: false,
    onSuccess: () => {
      queryClient.invalidateQueries("GetPersonContract");
      handleSuccess();
      setReset(true);
    },
    onError: () => {
      handleFailed();
    },
  });
};

const useGetPersonContract = (reqBody) => {
  const dispatch = useDispatch();
  let totalRecord;
  return useQuery(["GetPersonContract", reqBody], GetPersonContrat, {
    enabled: !!reqBody,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onSuccess: (data) => {
      dispatch(getOrderTotalR(totalRecord));
      return data;
    },
    onError: () => {},
    select: (data) => {
      totalRecord = data?.data.totalRecord; //for pagnation
      let getPersonContract = data?.data.data;
      return getPersonContract;
    },
  });
};
/**==============================================
 *                GetDependentInfo
 *  
  
 *=============================================**/
const useGetDependentInfo = (id) => {
  const body = {
    page: 1,
    pageSize: 100,
    searchTerm: "",
    id: id,
  };
  return useQuery(["GetDependentInfo", body], GetDependentInfo, {
    enabled: !!id,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onSuccess: (data) => {
      //dispatch(getOrderTotalR(totalRecord));
      return data;
    },

    select: (data) => {
      let getPersonContract = data?.data.data;
      return getPersonContract;
    },
  });
};
/**=======================
 *     useAddDependentInfo
 *========================**/
const useAddDependentInfo = (handleSuccess, handleFailed) => {
  const queryClient = useQueryClient();
  return useMutation(AddDependentInfo, {
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onSuccess: () => {
      queryClient.invalidateQueries("GetDependentInfo");
      handleSuccess();
    },
    onError: (error) => {
      handleFailed();
    },
  });
};
const useEditDependentInfo = (handleSuccess, handleFailed) => {
  const queryClient = useQueryClient();
  return useMutation(
    (body) =>
      customApi({
        apiType: "put",
        url: "/api/v1/DependentInfo/UpdateDependentInfo",
        reactQuery: "mutate",
        requestBody: body,
      }),
    {
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      onSuccess: (data) => {
        queryClient.invalidateQueries("GetDependentInfo");
        handleSuccess();
      },
      onError: (error) => {
        handleFailed();
      },
    }
  );
};

const useDependentInfo = (handleSuccess, handleFailed) => {
  const queryClient = useQueryClient();
  return useMutation(
    (body) =>
      customApi({
        apiType: "delete",
        url: "/api/v1/DependentInfo/DeleteDependentInfo",
        queryparameters: "dependentInfoId",
        reactQuery: "mutate",
        requestBody: body,
      }),
    {
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      onSuccess: (data) => {
        queryClient.invalidateQueries("GetDependentInfo");
        handleSuccess();
      },
      onError: (error) => {
        handleFailed();
      },
    }
  );
};

/**=======================
 *     useAddInsuranceInfo
 *========================**/
const useAddInsuranceInfo = (handleSuccess, handleFailed, setResInsData) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation(AddInsuranceInfo, {
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onSuccess: (data) => {
      handleSuccess();
      setResInsData(data);
      queryClient.invalidateQueries("GetInsuranceInfo");
      dispatch(AddInsuranceR(true));
    },
    onError: (error) => {
      handleFailed();
    },
  });
};

/**==============================================
 *                GetInsuranceInfo
 *
 *
 *
 *
 *=============================================**/
const useGetInsuranceInfo = (reqUnitsBody) => {
  const dispatch = useDispatch();
  let totalRecord;
  return useQuery(
    ["GetInsuranceInfo", reqUnitsBody],
    () =>
      customApi({
        apiType: "post",
        url: "/api/v1/InsuranceInfo/GetInsuranceInfoByPersonId",
        requestBody: reqUnitsBody,
        reactQuery: "query",
      }),
    {
      enabled: !!reqUnitsBody,
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      onSuccess: (data) => {
        dispatch(getOrderTotalR(totalRecord));
        return data;
      },

      select: (data) => {
        totalRecord = data?.data.totalRecord; //for pagnation
        let insuranceInfo = data?.data.data;

        return insuranceInfo;
      },
    }
  );
};

/**==============================================
 *                 EditInsuranceInfo
 *
 *
 *
 *
 *=============================================**/
const useEditInsuranceInfo = (handleSuccess, handleFailed) => {
  const queryClient = useQueryClient();
  return useMutation(
    (body) =>
      customApi({
        apiType: "put",
        url: "/api/v1/InsuranceInfo/UpdateInsuranceInfo",
        reactQuery: "mutate",
        requestBody: body,
      }),
    {
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      onSuccess: (data) => {
        queryClient.invalidateQueries("GetInsuranceInfo");
        handleSuccess();
      },
      onError: (error) => {
        handleFailed();
      },
    }
  );
};
/**==============================================
 *                delete Insurance
 *
 *
 *
 *
 *=============================================**/
const useDeleteInsurance = (handleSuccess, handleFailed) => {
  const queryClient = useQueryClient();
  return useMutation(
    (body) =>
      customApi({
        apiType: "delete",
        url: "/api/v1/InsuranceInfo/DeleteInsuranceInfo",
        queryparameters: "insuranceInfoId",
        reactQuery: "mutate",
        requestBody: body,
      }),
    {
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      onSuccess: (data) => {
        queryClient.invalidateQueries("GetInsuranceInfo");
        handleSuccess();
      },
      onError: (error) => {
        handleFailed();
      },
    }
  );
};

/**=======================
 *
 *  useAddUserAccount
 *
 *========================**/
const useAddUserAccount = (handleSuccess, handleFailed) => {
  return useMutation(AddUserAccount, {
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onSuccess: (data) => {
      handleSuccess();
    },
    onError: (error) => {
      const textError = error?.response?.data?.message;
      if (textError) {
        handleFailed(textError);
      } else {
        handleFailed();
      }
    },
  });
};

/**=======================================================================================================================
 *                                                     Edite Api
 *=======================================================================================================================**/

/**----------------------
 *    get Person
 *------------------------**/
const useGetPersonById = (reqUnitsBody) => {
  return useQuery(
    ["GetPersonById ", reqUnitsBody],
    () =>
      customApi({
        apiType: "post",
        url: "/api/v1/Person/GetPersonById",
        requestBody: reqUnitsBody,
        reactQuery: "query",
      }),
    {
      enabled: !!reqUnitsBody,
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      onSuccess: (data) => {
        return data;
      },

      select: (data) => {
        let result = data?.data.data;

        return result;
      },
    }
  );
};
/**-----------------------
 *     Edit Person
 *
 *
 *------------------------**/
const useEditPerson = (handleSuccess, handleFailed) => {
  return useMutation(
    (body) =>
      customApi({
        apiType: "post",
        url: "/api/v1/Person/EditPerson",
        requestBody: body,
        reactQuery: "mutate",
      }),
    {
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      onSuccess: (data) => {
        handleSuccess();
        return data;
      },
      onError: () => {
        handleFailed();
      },
    }
  );
};
/**----------------------
 *    get PersonInfo
 *------------------------**/
const useGetPersonInfoById = (reqUnitsBody) => {
  return useQuery(
    ["GetPersonById ", reqUnitsBody],
    () =>
      customApi({
        apiType: "post",
        url: "/api/v1/Person/GetPersonInfoById",
        requestBody: reqUnitsBody,
        reactQuery: "query",
      }),
    {
      enabled: !!reqUnitsBody,
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      onSuccess: (data) => {
        return data;
      },
      onError: () => {},
      select: (data) => {
        let result = data?.data.data;
        return result;
      },
    }
  );
};
/**----------------------
 *   get user person
 *
 *------------------------**/
const useGetUserPerson = (reqUnitsBody) => {
  return useQuery(
    ["GetUserPerson ", reqUnitsBody],
    () =>
      customApi({
        apiType: "post",
        url: "/api/v1/User/GetUserByPersonId",
        requestBody: reqUnitsBody,
        reactQuery: "query",
      }),
    {
      enabled: !!reqUnitsBody,
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      onSuccess: (data) => {
        return data;
      },
      onError: () => {},
      select: (data) => {
        let user = data?.data.data;

        return user;
      },
    }
  );
};

/**----------------------
 *    edit user person
 *------------------------**/
const useEditUserPerson = (handleSuccess, handleFailed) => {
  return useMutation(
    (body) =>
      customApi({
        apiType: "post",
        url: "/api/v1/Person/EditPerson",
        requestBody: body,
        reactQuery: "mutate",
      }),
    {
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      onSuccess: (data) => {
        handleSuccess();
        return data;
      },
      onError: () => {
        handleFailed();
      },
    }
  );
};

/**----------------------------------------------
 *                get person post
 *  

 *---------------------------------------------**/
const useGetPersonPost = (reqUnitsBody) => {
  return useQuery(
    ["GetPersonPost ", reqUnitsBody],
    () =>
      customApi({
        apiType: "post",
        url: "/api/v1/Person/GetPersonPosts",
        requestBody: reqUnitsBody,
        reactQuery: "query",
      }),
    {
      enabled: !!reqUnitsBody,
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      onSuccess: (data) => {
        return data;
      },
      onError: () => {},
      select: (data) => {
        let user = data?.data.data;
        return user;
      },
    }
  );
};

/**----------------------------------------------
 *                Account Get all Posts
 *
 *---------------------------------------------**/
const useGetAllPostChart = (reqUnitsBody) => {
  const dispatch = useDispatch();
  let totalRecord;
  return useQuery(
    ["GetAllPostChart", reqUnitsBody],
    () =>
      customApi({
        apiType: "post",
        url: "/api/v1/ChartPostPerson/GeAllChartAndPost",
        requestBody: reqUnitsBody,
        reactQuery: "query",
      }),
    {
      enabled: !!reqUnitsBody,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        dispatch(getOrderTotalR(totalRecord));

        return data;
      },
      onError: () => {},
      select: (data) => {
        totalRecord = data?.data.totalRecord; //for pagnation
        let result = data?.data.data;

        return result;
      },
    }
  );
};
/**==============================================
 *                add Range Chart Post Person
 *
 *
 *
 *
 *=============================================**/
const useAddRangeChartPostPerson = (handleSuccess, handleFailed) => {
  const queryClient = useQueryClient();
  return useMutation(
    (body) =>
      customApi({
        apiType: "post",
        url: "/api/v1/ChartPostPerson/AddRangeChartPostPerson",
        reactQuery: "mutate",
        requestBody: body,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("GetAllPostChart");
        handleSuccess("ثبت با موفقیت انجام  شد");
      },
      onError: () => {
        handleFailed();
      },
    }
  );
};
const useGetAllBatizEmployeesAsync = () => {
  const dispatch = useDispatch();
  let totalRecord;
  return useQuery(
    ["GetAllBatizEmployeesAsync"],
    () =>
      customApi({
        apiType: "get",
        url: "/api/v1/Person/GetAllBatizEmployeesAsync",
        reactQuery: "query",
      }),
    {
      refetchOnWindowFocus: false,

      select: (data) => {
        let result = data?.data.data;

        return result;
      },
    }
  );
};
export {
  useGetEnumsValue,
  useGetAllPerson,
  useDeletePeson,
  useGetAllEducationalDegree,
  useGetAllEmployeeStatus,
  useAddPerson,
  useGetAllProvince,
  useGetCitiesByProvince,
  useEditPersonInfo,
  useGetBankInfo,
  useGetPersonBankInfo,
  useAddPersonBankInfo,
  useDeletePersonBankInfo,
  useEditPersonBankInfo,
  useUploadDocument,
  useGetDocument,
  useUploadContract,
  useEditContract,
  useDeleteContract,
  useGetPersonContract,
  useAddDependentInfo,
  useGetInsuranceInfo,
  useAddInsuranceInfo,
  useEditInsuranceInfo,
  useDeleteInsurance,
  useGetDependentInfo,
  useEditDependentInfo,
  useDependentInfo,
  useAddUserAccount,
  useGetBankInfoForPeron,

  //edit api
  useGetPersonById,
  useEditPerson,
  useGetPersonInfoById,
  useUpdateDocument,
  useGetUserPerson,
  useEditUserPerson,
  useGetPersonPost,
  useGetAllPostChart,
  useAddRangeChartPostPerson,
  useGetAllBatizEmployeesAsync
};
